import { t } from '@lingui/macro';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import { VirtualMachineFilter, TimeRangeFilter, useVirtualMachine, virtualMachineFilterId } from '../../filters';
import { useSummarizedFilterStateById } from '../../../stores/FilterStateStore';
import { LAYOUT_WIDTH } from '../../page-framework/panel-container/PanelContainer';

import {
    VirtualMachineStatusPanel,
    VirtualMachineCpuUtilizationPanel,
    VirtualMachineMemoryUtilizationPanel,
    VirtualMachineDiskLatencyPanel,
    VirtualMachineDiskIOPanel,
    VirtualMachineNetworkUtilizationPanel,
    VirtualMachineCpuReadyPanel,
    VirtualMachinePacketDropsPanel,
    VirtualMachineSyslogPanel,
    VirtualMachinePropertiesPanel,
} from '../../panels';

export const pageId = 'vmware-vm-detail';

export default function VirtualMachineDetailPage() {
    const virtualMachine = useVirtualMachine();
    const [isAdminUser] = useIsAdminUser();
    const [summarized] = useSummarizedFilterStateById(virtualMachineFilterId);
    const title = summarized?.value;

    return (
        <Page id={pageId}>
            <PageHeader
                title={title}
                titleActions={
                    virtualMachine &&
                    !virtualMachine.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link
                                to={`/admin/virtual-infrastructure/${virtualMachine?.uuid}`}
                                title={t`Edit virtual machine configuration`}
                            >
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <VirtualMachineFilter required />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <VirtualMachineStatusPanel width={LAYOUT_WIDTH.FULL} title={t`Status`} />
                <VirtualMachineCpuUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`CPU Utilization`} />
                <VirtualMachineMemoryUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Memory Utilization`} />
                <VirtualMachineDiskLatencyPanel width={LAYOUT_WIDTH.HALF} title={t`Disk Latency (Max)`} />
                <VirtualMachineDiskIOPanel width={LAYOUT_WIDTH.HALF} title={t`Disk I/O`} />
                <VirtualMachineNetworkUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Network I/O`} />
                <VirtualMachineCpuReadyPanel width={LAYOUT_WIDTH.HALF} title={t`CPU Ready`} />
                <VirtualMachinePacketDropsPanel width={LAYOUT_WIDTH.FULL} title={t`Packet Drops`} />
                <VirtualMachineSyslogPanel width={LAYOUT_WIDTH.FULL} title={t`Syslog Events`} />
                <VirtualMachinePropertiesPanel width={LAYOUT_WIDTH.FULL} title={t`Properties`} />
            </PanelContainer>
        </Page>
    );
}
